export const signupData = {
    "name": "",
    "username": "",
    "age": 23,
    "email": "",
    "password": "",
    "financialinfo": {
      "budget": [],
      "transaction": [],
      "withdraw": []
    }
  }